export default __webpack_public_path__ + "245396b6f304e07c198d05cb4c207133.png";